import React from 'react';
import DaoGovernorRealDataTable from '@/components/tables/DaoGovernorRealDataTable';
import { useAuth } from '@/contexts/AuthContext';

interface DaoGovernorPageProps {
  onNavigate: (view: string) => void;
}

const DaoGovernorPage: React.FC<DaoGovernorPageProps> = ({ onNavigate }) => {
  const { currentUser } = useAuth();
  return (
    <div className="space-y-8 animate-in fade-in">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white mb-1">DAO Governor Dashboard</h1>
        <button
          onClick={() => onNavigate('dashboard')}
          className="bg-kala-secondary hover:bg-cyan-400 text-kala-900 font-bold py-2 px-4 rounded"
        >
          Back to Dashboard
        </button>
      </div>
      <div id="dao-governor-tables" className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
        <DaoGovernorRealDataTable currentUserRole={currentUser.role} currentUserId={currentUser.id} />
      </div>
    </div>
  );
};

export default DaoGovernorPage;